export default "__VITE_ASSET__BwIPFAjV__"